import BaseModal from 'components/Modals/BaseModal';
import { Button } from 'react-bootstrap';

export default function DeleteAudioModal({ show, audioName, onCancel, onConfirm }) {
  // Level 3: the device/group settings modal and Audio Manager are below this confirmation.
  return (
    <BaseModal
      show={show}
      handleShow={onCancel}
      size="sm"
      closeButton={false}
      backgroundColor="var(--bs-body-bg)"
      borderWidth="1px"
      borderColor="var(--bs-secondary)"
      stackLevel={3}
    >
      <div className="d-flex flex-column gap-3">
        <h6 className="mb-0">Delete audio file?</h6>
        <p className="mb-0 small text-muted">
          {audioName || 'This file'} will be permanently deleted.
        </p>
        <div className="d-flex justify-content-end gap-2">
          <Button size="sm" variant="outline-secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="sm" variant="danger" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </BaseModal>
  );
}
